import cloneDeep from "lodash.clonedeep"
import {BaseWidgetModel} from "~/site/model/models/base"
import {hasOwn} from "~/utils"
import {LangIdMap} from "~/config/language"
import { ModuleNameEnum, NavTypeEnum } from '~/enums/siteEnum'
import {generateDefaultBackground} from "~/site/model/helper"
import {DefaultImage} from "~/enums/defaultImageEnum"

export class DialogWidgetModel extends BaseWidgetModel {
  constructor(options = {}) {
    super(options)
    const defaultList = [
      {
        title: `<p class="ql-align-center"><span class="ql-size-large">${ LangIdMap.DialogTitle }</span></p>`,
        subtitle: `<p class="ql-align-center"><span class="ql-size-normal">${ LangIdMap.DialogSubtitle }</span></p>`,
        background: generateDefaultBackground({ backgroundImage: DefaultImage.Dialog }),
        navType: NavTypeEnum.URL,
        url: '',
        page: '',
        model: '',
      }
    ]
    this.name = 'DialogWidgetModel'
    this.background = hasOwn(options, 'background', '', generateDefaultBackground({ backgroundColor: 'rgba(104, 103, 103, 0.62)' }))
    this.contentBackground = hasOwn(options, 'contentBackground', '', generateDefaultBackground())
    this.radius = hasOwn(options, 'radius', '', 0)
    this.loadVisible = hasOwn(options, 'loadVisible', '', false) || false
    this.buttonText = hasOwn(options, 'buttonText', '', 'Confirm')
    this.buttonVisible = hasOwn(options, 'buttonVisible', '', true)
    this.titleVisible = hasOwn(options, 'titleVisible', '', true)
    this.subtitleVisible = hasOwn(options, 'subtitleVisible', '', true)
    this.list = hasOwn(options, 'list', '', defaultList)
    this.moduleName = ModuleNameEnum.Dialog
    this.__maxLength = 5
    this.__refresh = null
    this.__onMenuSelected = function (model, context) {
      context.$store.commit('site/SET_DIALOG_VISIBLE', true)
      context.$nextTick(() => {
        document.querySelector('.edit-content__center--wrapper').scrollTop = 0
      })
    }

    this.__addItem = function () {
      this.list.push(cloneDeep(defaultList[0]))
    }

    this.__getLang = () => {
      return {
        list: this.list.map(item => {
          return {
            title: item.title,
            subtitle: item.subtitle
          }
        }),
        buttonText: this.buttonText
      }
    }
    this.getMenuInfo = () => {
      return {
        id: this.id,
        title: 'dialog',
        name: ModuleNameEnum.Dialog,
        model: this.constructor,
        draggable: false,
        isDefault: false
      }
    }
  }
}
